/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

// Angular
import { Component, Input, ViewChild, ElementRef } from '@angular/core';

import { UserProfile } from '../../models/user';

@Component({
	selector: 'celine-threshold-user-profile-switch',
	template: require('./user-profile-switch.component.html')
})

export class UserProfileSwitchComponent {

    @Input('userProfiles') userProfiles: UserProfile[];

	@ViewChild('userProfilesList') userProfilesList: ElementRef;
    @ViewChild('toggleIcon') toggleIcon: ElementRef;

    featTogLocalization = process.env.config.feature.localization.enabled;

    constructor() { }

    onToggleUserProfiles(ev: MouseEvent) {
        this.userProfilesList.nativeElement.classList.toggle("d-none");
        this.toggleIcon.nativeElement.classList.toggle("ico-chevron-up");
        this.toggleIcon.nativeElement.classList.toggle("ico-chevron-down");
        ev.stopPropagation();
    }

    onClickSelected(ev: MouseEvent) {
        // avoid close dropdown when already selected profiles is clicked
        ev.stopPropagation();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/user/user-profile-switch.component.ts